<template lang="pug">
footer.section-gap.footer-widget-area
  .overlay.overlay-bg
  .container
    .subscription-area
      .row
        .col-lg-6
          router-link(to="/")
            img.logo(src='/static/img/logo_w.png')
    .row
      .col-lg-3.col-sm-6
        .single-footer-widget
          h6.text-white.text-uppercase.mb-20 {{ $t('footer.about') }}
          ul.footer-nav
            li
              router-link(to="/") {{ $t('footer.aboutLink.concept') }}
            li
              router-link(to="/") {{ $t('footer.aboutLink.how') }}
            li
              router-link(to="/") {{ $t('footer.aboutLink.help') }}
            li
              router-link(to="/") {{ $t('footer.aboutLink.legal') }}
      .col-lg-3.col-sm-6
        .single-footer-widget
          h6.text-white.text-uppercase.mb-20 {{ $t('footer.contact') }}
          ul.footer-nav
            li
              router-link(to="/") {{ $t('footer.contactLink.team') }}
            li
              router-link(to="/") {{ $t('footer.contactLink.contact') }}
            li
              router-link(to="/") {{ $t('footer.contactLink.social') }}
      .col-lg-3.col-sm-6
        .single-footer-widget
          h6.text-white.text-uppercase.mb-20 {{ $t('footer.technical') }}
          ul.footer-nav
            li
              router-link(to="/") {{ $t('footer.technicalLink.sitemap') }}
            li
              router-link(to="/") {{ $t('footer.technicalLink.contribute') }}
            li
              router-link(to="/") {{ $t('footer.technicalLink.report') }}
            li
              router-link(to="/") {{ $t('footer.technicalLink.source') }}
      .col-lg-3.col-sm-6
        .single-footer-widget
    .footer-bottom.d-flex.justify-content-between.align-items-center.flex-wrap
      p.footer-text.m-0(v-html="$t('footer.copy', { year })")
      .footer-social.d-flex.align-items-center
        a(href='https://facebook.com', target="_blank")
          i.fa.fa-facebook
        a(href='https://twitter.com', target="_blank")
          i.fa.fa-twitter
        a(href='https://github.com', target="_blank")
          i.fa.fa-github
</template>

<script>
import Project from '@/constants';

export default {
  name: 'Footer',
  data() {
    return {
      year: Project.startYear,
    };
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'

.logo
  max-height 75px

.subscription-area
  padding-bottom base-padding + 15px
</style>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue